import * as React from "react";
import AccountingTable from "../common/AccountingTable2C";
import { BankDetailConstants as Constants } from "../constants";

type AccountLine = {
    label: string,
    amount: string,
    className: string,
    link: string
}

const AssetFormat : AccountLine[] = [
    {"label":Constants.ASSET_CASH,"amount":"0", "className":"","link":""},
    {"label":Constants.ASSET_DUE,"amount":"0", "className":"","link":""},
    {"label":Constants.ASSET_LIQUID,"amount":"0", "className":"","link":""},
    {"label":Constants.ASSET_LOSS,"amount":"0", "className":"sumRow","link":"2"},
    {"label":Constants.FILLER,"amount":Constants.FILLER, "className":"","link":""},
    {"label":Constants.FILLER,"amount":Constants.FILLER, "className":"","link":""},
    {"label":Constants.FILLER,"amount":Constants.FILLER, "className":"","link":""}
];

interface AssetTableProps {
    cash: string;
    due: string;
    liquid: string;
    loss: string;
    total: string;
}

class AssetTable extends React.Component<AssetTableProps, any> {
    // eslint-disable-next-line
    constructor(props: AssetTableProps) {
        super(props);
    }

    render() {
        let data : AccountLine[] = AssetFormat;
        
        data[0].amount = this.props.cash || "0";
        data[1].amount = this.props.due || "0";
        data[2].amount = this.props.liquid || "0";
        data[3].amount = this.props.loss || "0";

        return(
            <React.Fragment>
                <AccountingTable 
                    headers={Constants.ASSET_HEADER} 
                    data={data} 
                    totalLabel={Constants.ASSET_TOTAL}
                    totalAmount={this.props.total}
                />
            </React.Fragment>
        )
    }
}

export default AssetTable;